import type { NextBuild } from '@common/types/userType.ts';

export const filterTargetBuilds = (builds: NextBuild[]): NextBuild[] => {
  const targetPlants = ['wood', 'lumber', 'furniture_factory'];

  return builds.filter((build) => targetPlants.includes(build.plant));
};
